import { UserType } from "@src/types.generated";
import React, { FC } from "react";
import Text, { textVariants } from "@src/lib/ui/Text";
import { cn } from "@src/lib/utils/cn";

type Props = {
  userType: UserType;
};

const UserTypeDescription: FC<Props> = ({ userType }) => {
  return (
    <>
      {userType === UserType.Employee && (
        <p className="mt-2 w-full rounded-lg bg-blue-1 p-3 text-[13px] leading-5 font-normal text-blue-9">
          A Trainee only has access to the Trainee app.
        </p>
      )}
      {userType === UserType.Admin && (
        <div className="mt-2 w-full rounded-lg bg-blue-1 p-3 text-[13px] leading-5 font-normal text-blue-9">
          <Text variant="compact-description" multiline className="text-blue-9">
            Admins have full access to all locations, content, and settings by
            default
          </Text>
        </div>
      )}
      {userType === UserType.Manager && (
        <div className="mt-2 w-full rounded-lg bg-blue-1 p-3 text-[13px] leading-5 font-normal text-blue-9">
          <Text
            variant="compact-description"
            multiline
            className={cn("text-blue-9", "mb-1")}
          >
            Managers can do everything an Admin can do except:
          </Text>
          <ul className="my-0 ml-4 flex list-disc flex-col gap-1 p-0">
            <li className={textVariants({ variant: "P2" })}>
              View all Trainees and Locations
            </li>
            <li className={textVariants({ variant: "P2" })}>
              Edit content they did not create
            </li>
            <li className={textVariants({ variant: "P2" })}>
              Edit organization settings
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default UserTypeDescription;
